var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitiesWinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9999 84H14.9999V78H83.9999C88.7599 78 93.2774 76.2275 96.7174 73.0125C100.125 69.8275 102 65.6425 102 61.2325C102 54.4925 97.7949 48.4225 91.2849 45.765L93.5524 40.21C102.33 43.7925 108 52.0425 108 61.2325C108 67.3225 105.447 73.0625 100.815 77.395C96.2599 81.655 90.2874 84 83.9999 84Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9999 69H23.9999C19.0374 69 14.9999 64.9625 14.9999 60C14.9999 55.0375 19.0374 51 23.9999 51H86.9999C91.9624 51 95.9999 55.0375 95.9999 60C95.9999 64.9625 91.9624 69 86.9999 69ZM23.9999 57C22.3449 57 20.9999 58.345 20.9999 60C20.9999 61.655 22.3449 63 23.9999 63H86.9999C88.6549 63 89.9999 61.655 89.9999 60C89.9999 58.345 88.6549 57 86.9999 57H23.9999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 66H29.9999V78H35.9999V66Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9999 66H71.9999V78H77.9999V66Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6699 48.81L61.0024 42.81L53.3374 48.81L45.6699 42.81L38.0024 48.81L30.3349 42.81L22.6674 48.81L13.1499 41.3625L16.8499 36.6375L22.6674 41.19L30.3349 35.19L38.0024 41.19L45.6699 35.19L53.3374 41.19L61.0049 35.19L68.6699 41.19L76.3349 35.19L85.8499 42.6375L82.1499 47.3625L76.3349 42.81L68.6699 48.81Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesWinter);
export default __webpack_public_path__ + "static/media/ActivitiesWinter.30ee474f.svg";
export { ForwardRef as ReactComponent };